// extracted by mini-css-extract-plugin
export var buttonContainer = "style-module--buttonContainer--800c6";
export var share = "style-module--share--02a74";